<template>
    <img :src="thumbUrl" :alt="label" :title="label"/>
</template>

<script>
    export default {
        'props': {
            fabricator: {
                required: true,
            },
            label: {
                required: true,
            },
            thumb_path: {
                required: true,
            },
        },
        computed: {
            thumbUrl() {
                if(window.designer_thumbs_use_cdn == '1') {
                    return window.designer_thumbs_cdn_bucket_url + this.fabricator + this.thumb_path + '.png';
                }

                return this.thumb_path;
            }
        }
    }
</script>
